module.exports = __webpack_public_path__ + "static/media/ru_kindergarten_instruction.04a7459e.pdf";